'use client';

import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// IMPORT SWIPER CSS ONCE HERE
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Register modules ONCE
SwiperCore.use([Navigation, Pagination]);

export { Swiper, SwiperSlide, Navigation, Pagination };